import { createContext, useState } from "react";

export const ModalContext = createContext();

export const ModalProvider = ({children}) => {
    const [isModal, setIsModal] = useState(true);

    const toggleIsModal = () => {
        setIsModal(isModal === false ? true : false)
    }

    return (
        <ModalContext.Provider value={{isModal, toggleIsModal}}>
            {children}
        </ModalContext.Provider>
    )
}